import { DownCaratIcon, useIconSize } from 'foundations-assets';
import { StyledDownCaratIconWrapper } from './Select.styles';
import { useInputGroupContext } from '../../transitional/components/InputGroup/InputGroupProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const DownCarat = ({
  hasSelectedValues,
  clearable
}) => {
  const inputGroupContext = useInputGroupContext();
  const iconSize = useIconSize('100');
  if (clearable) {
    if (!hasSelectedValues) {
      return /*#__PURE__*/_jsx(StyledDownCaratIconWrapper, {
        $size: iconSize,
        $selectStylesOverrides: inputGroupContext === null || inputGroupContext === void 0 ? void 0 : inputGroupContext.selectStylesOverrides,
        children: /*#__PURE__*/_jsx(DownCaratIcon, {})
      });
    }
    return null;
  }
  return /*#__PURE__*/_jsx(StyledDownCaratIconWrapper, {
    $size: iconSize,
    $selectStylesOverrides: inputGroupContext === null || inputGroupContext === void 0 ? void 0 : inputGroupContext.selectStylesOverrides,
    children: /*#__PURE__*/_jsx(DownCaratIcon, {})
  });
};